export const ROOT_SLUG_ROUTE = Object.freeze({
  BLOG: "blog",
  PRESS_RELEASE: "press-release",
  LOCATION: "location",
});

export function getRootSlugRoute(slug = "") {
  if (slug.startsWith("blog-")) {
    return ROOT_SLUG_ROUTE.BLOG;
  }

  if (slug.startsWith("pressrelease-")) {
    return ROOT_SLUG_ROUTE.PRESS_RELEASE;
  }

  return ROOT_SLUG_ROUTE.LOCATION;
}
